// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?indentedSyntax!./style.sass");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("1e138dea", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/style.sass
// module id = 43
// module chunks = 0